const notifications = {
  lockdown: 'Confinement',
  door_alarmed: 'Porte forcée',
  reader_tamper: 'Sabotage du lecteur',
  tamper: 'Sabotage du boîtier',
  batteries_trouble: 'Problème de batterie',
  power_trouble: "Problème d'alimentation principale",
  module_offline: 'Module hors ligne',
};

export default notifications;
